import { supabase } from './supabase';
import type { BillingStatus } from './billing';

/**
 * Service de facturation (Brique 3·D) — écriture Supabase.
 * L'app ne fait que METTRE À JOUR le statut de facturation d'un resto (l'encaissement
 * reste dans Odoo). La RLS interdisant l'UPDATE direct sur `tenants`, on passe par la
 * RPC sécurisée `set_tenant_billing` (SECURITY DEFINER, réservée au super_admin),
 * cf. sql/20_billing.sql. Logique pure dans billing.ts (testée à part).
 */

export interface SetBillingInput {
  tenantId: string;
  status: BillingStatus;
  /** Fin d'essai ISO (si status = 'trial'), sinon null. */
  trialEndsAt?: string | null;
  /** Note libre. Conservée telle quelle si non fournie (coalesce côté SQL). */
  notes?: string | null;
  /** Id fiche client Odoo. Conservé tel quel si non fourni. */
  odooPartnerId?: string | null;
}

export interface SetBillingResult {
  ok: boolean;
  /** message d'erreur prêt à afficher (si échec). */
  error?: string;
}

/**
 * Change la facturation d'un resto via la RPC sécurisée.
 * Tolérant : renvoie un résultat clair, l'UI décide quoi afficher.
 */
export async function setBilling(input: SetBillingInput): Promise<SetBillingResult> {
  const { error } = await supabase.rpc('set_tenant_billing', {
    p_tenant_id: input.tenantId,
    p_status: input.status,
    p_trial_ends_at: input.trialEndsAt ?? null,
    p_notes: input.notes ?? null,
    p_odoo_partner_id: input.odooPartnerId ?? null,
  });
  if (error) {
    return { ok: false, error: `Mise à jour de la facturation impossible : ${error.message}` };
  }
  return { ok: true };
}
